export default __webpack_public_path__ + "locales/es/Translations.json?hash=32547017927afa462c125de1b2026eb0";